function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#AEFF00;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#16161A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M48.9,27.7l2.1-2.2c0.7-0.7,0.6-1.9-0.1-2.6c-0.7-0.7-1.9-0.6-2.6,0.1l-1.4,1.5v-6.6c0-1-0.8-1.8-1.8-1.8h-9.5 C34.7,7,27.1,0,17.9,0C8,0,0,8,0,17.9c0,8.4,5.9,15.5,13.8,17.4l-2.3,2.2c-0.7,0.7-0.8,1.8-0.1,2.6c0.7,0.7,1.8,0.8,2.6,0.1l2.1-2v7 c0,1,0.8,1.8,1.8,1.8h9.5C28.3,56,35.9,63,45.1,63C55,63,63,55,63,45.1C63,36.6,57,29.4,48.9,27.7z M27.4,43.3h-7.7v-4.8l1.4,1.5 c0.4,0.4,0.8,0.6,1.3,0.6c0.4,0,0.9-0.2,1.2-0.5c0.7-0.7,0.8-1.8,0.1-2.6l-2.1-2.2c7.5-1.6,13.2-7.9,14-15.6h7.7v5.2l-2.1-2 c-0.7-0.7-1.9-0.7-2.6,0.1c-0.7,0.7-0.7,1.9,0.1,2.6l2.3,2.2C33.7,29.4,28.1,35.7,27.4,43.3z M49.7,43.3c1,0,1.8,0.8,1.8,1.8v2.7 c0,2.6-2,4.7-4.5,4.8v1.6c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8v-1.6h-2.7c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8h6.1 c0.7,0,1.2-0.5,1.2-1.2v-0.8h-7.3c-1,0-1.8-0.8-1.8-1.8v-2.7c0-2.6,2-4.7,4.5-4.8V36c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8v1.6 h2.7c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8h-6.1c-0.7,0-1.2,0.5-1.2,1.2v0.8H49.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 9,
  y: 8,
  width: 18,
  height: 22
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M24.8,13.9c-0.1-0.8-0.3-1.6-0.7-2.3c-1.2-2.1-2.9-3.2-5.2-3.5c-1.3-0.2-2.6,0-3.8,0.6 c-1.9,0.9-3.2,2.3-3.7,4.3c-0.1,0.4-0.2,0.7-0.2,1.1c0,0-0.1,0-0.1,0c-0.4-0.1-0.8-0.1-1.2-0.1c-0.5,0.1-0.9,0.5-0.8,1 c0,0.3,0.1,0.5,0.2,0.8c0.1,0.2,0.2,0.4,0.3,0.5c0.4,0.6,0.8,1.2,1.2,1.8c0.2,0.2,0.3,0.5,0.3,0.8c0,0.5,0,1-0.1,1.5 c-0.1,0.7,0,1.4,0.1,2.1c0.1,0.8,0.5,1.5,0.8,2.2c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.1,0.2,0c0.1-0.1,0.1-0.2,0.2-0.3 c0.1-0.2,0.3-0.2,0.4,0c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.3,0.2,0.6,0.3,0.8c0.1,0.2,0.2,0.4,0.3,0.6c0.1-0.1,0.2-0.2,0.3-0.3 c0.2-0.2,0.4-0.1,0.6,0.1c0.1,0.1,0.1,0.2,0.2,0.4c0.2,0.4,0.4,0.8,0.6,1.3c0.1,0.3,0.3,0.5,0.5,0.8l0.1,0c0-0.1,0-0.1,0-0.2 c0.1-0.2,0.1-0.5,0.2-0.7c0.2-0.5,0.7-0.6,1.1-0.2c0.2,0.2,0.3,0.4,0.4,0.7c0.3,0.6,0.4,1.2,0.5,1.8c0,0.1,0,0.2,0.1,0.2l0.1,0 c0-0.1,0.1-0.1,0.1-0.2c0.2-0.5,0.5-1,0.7-1.4c0.1-0.3,0.4-0.4,0.7-0.3c0.1,0,0.2,0.1,0.3,0.1c0.1-0.5,0.5-0.9,0.8-1.3 c0.3-0.3,0.5-0.2,0.7,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.1,0.1,0.2c0.1-0.3,0.2-0.5,0.3-0.7c0.1-0.3,0.2-0.6,0.3-0.9 c0.1-0.5,0.3-1,0.6-1.4c0.1-0.2,0.4-0.2,0.6,0c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.3,0.2,0.4c0,0,0-0.1,0.1-0.1 c0.6-0.9,1-2,1-3.2c0-0.9,0-1.8,0-2.7c0-0.5,0.1-0.9,0.4-1.3c0.5-0.6,0.9-1.2,1.3-1.8c0.2-0.2,0.3-0.5,0.3-0.8 c0.1-0.5,0-0.9-0.5-1c-0.2-0.1-0.4-0.1-0.6-0.1C25.5,13.9,25.2,13.9,24.8,13.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M20.8,14.9c0.9,0,1.4-0.6,1.3-1.5c-0.1-0.3-0.2-0.4-0.5-0.3c-0.4,0.1-0.8,0.3-1.2,0.5c-0.1,0-0.2,0.1-0.2,0.2 c-0.2,0.3-0.2,0.5-0.1,0.8c0.1,0.3,0.3,0.3,0.5,0.3C20.7,14.9,20.8,14.9,20.8,14.9z M15.1,14.9c0.1,0,0.2,0,0.3,0 c0.2,0,0.3-0.1,0.4-0.3c0.1-0.4,0-0.8-0.4-1c-0.4-0.2-0.7-0.3-1.1-0.5c-0.3-0.1-0.4,0-0.5,0.3C13.7,14.3,14.2,15,15.1,14.9 L15.1,14.9z"
}));

function SvgTransactionIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 63",
    style: {
      enableBackground: "new 0 0 63 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref5));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIconGreen);
export default __webpack_public_path__ + "static/media/transactionIcon-green.3dcc252d507cc97af67539e348d88aed.svg";
export { ForwardRef as ReactComponent };